import { useState } from 'react';
import { Row, Col, Nav } from 'react-bootstrap';
import SwiperCore, { EffectCoverflow, Pagination, Navigation } from 'swiper';
import Constants from "../../contants";
import { useTranslation } from 'react-i18next';
import SEO from '../../component/util/SEO';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import './portfolio.css';
let projects = Constants.projects;
const categories = [
  { value: 'All', labelKey: 'All' },
  { value: 'Blockchain', labelKey: 'blockchain' },
  { value: 'Custom Solution', labelKey: 'customSolution' },
  { value: 'Data Visualization', labelKey: 'dataVisualization' },
  { value: 'Designing', labelKey: 'designing' },
  { value: 'Cloud Hosting', labelKey: 'cloudHosting' },
  { value: 'Mobile', labelKey: 'mobile' },
  { value: 'Web', labelKey: 'web' },
  { value: 'Shopify', labelKey: 'shopify' },
  { value: 'Scripts', labelKey: 'scripts' },
];
// Initialize Swiper core modules
SwiperCore.use([EffectCoverflow, Pagination, Navigation]);

const Portfolio = () => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState('All'); // Initialize state

  // Filter projects based on the selected category
  const filteredProjects = selectedCategory === 'All'
    ? projects
    : projects.filter(project => (
      Array.isArray(project.Category)
        ? project.Category.includes(selectedCategory)
        : project.Category === selectedCategory
    ));
  return (
    <>
      <main className="portfolio-page night-theme" id="portfolio-main-content">
        <SEO
          title="Portfolio and Case Studies"
          description="Explore BringIt Go case studies across web development, Shopify, cloud hosting, data visualization, UI/UX design, blockchain, and custom software."
          canonical="https://www.bringitgo.tech/portfolio"
          keywords="web development portfolio, software case studies, Shopify case studies, cloud hosting projects, UI UX portfolio"
        />
        <section className="projects" id="portfolio" aria-labelledby="portfolio-heading">
          <Row>
            <Col>
              <h1 id="portfolio-heading" className="portfolio-heading">{t("portfolio")}</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className='portfolio-description'>{t("portfolioDescription")}</p>
            </Col>
          </Row>
          <div className='projects-container-background'>
            <Row>
              <h2 className='project-heading mt-5'>{t("casestudies")}</h2>
            </Row>
            <Row>
              <Nav variant="underline" className="projects-types" aria-label="Filter portfolio projects">
                {categories.map((category) => (
                  <Nav.Link
                    as="button"
                    type="button"
                    key={category.value}
                    className={`project-type border px-3 d-flex text-white align-items-center ${selectedCategory === category.value ? 'active' : ''}`}
                    onClick={() => setSelectedCategory(category.value)}
                    aria-pressed={selectedCategory === category.value}
                  >
                    {t(category.labelKey)}
                  </Nav.Link>
                ))}
              </Nav>
            </Row>
            <Row as="ul" className="portfolio-project-list">
              {filteredProjects.map((project) => (
                <Col as="li" className='d-flex justify-content-center p-3 m-1' lg={5} md={10} key={project.id}>
                  <article className="portfolio-project-card">
                    <div className='project-container-background' aria-hidden="true"></div>
                    <a href={project.Link} aria-label={`Read the ${project.Name} case study`}>
                      <img
                        className='portfolio-project-image'
                        src={project.Image}
                        alt={`${project.Name} case study by BringIt Go`}
                        loading="lazy"
                        decoding="async"
                        width={400}
                        height={300}
                      />
                      <h3 className='portfolio-project-heading'>{project.Name}</h3>
                    </a>
                  </article>
                </Col>
              ))}
            </Row>
          </div>

          {/* <Row className='vertical-swiper'>
          <Swiper
            direction="vertical"
            effect="coverflow"
            grabCursor
            centeredSlides
            loop
            pagination={{ clickable: true }}
            classNames={{
              wrapper: 'vertical-swiper-wrapper',
              slide: 'vertical-swiper-slide',
              pagination:'vertical-swiper-pagination',
              // Add more class names as needed
            }}
            className="vertical-swiper-container"
          >
            {projectData.map((project) => (
              <SwiperSlide key={project.id}>
                <div className="vertical-swiper-slide-content">
                  <a href={`/project/${project.id}`}>
                    <img className='vertical-img' src={project.image} alt={`Project ${project.id}`} />
                  </a>
                  <div className="project-info">
                    <h3>{project.heading}</h3>
                    <p>{project.description}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Row> */}
        </section>
      </main>
    </>
  );
};

export default Portfolio;
